import React, { useEffect } from "react";
import { ModalWithTitle } from "../RfModal/ModalWithTitle";
import Button from "../Button";
import { PlanCard } from "../Billing/PlanCard";
import { TrialExpirationChip } from "./TrialExpirationChip";
import { getIconForWorkspacePlan } from "../../../routes/workspace/utils";
import { PLAN_UBP } from "@functions/plans/info/ubp";
import { Plan } from "@functions/plans/types";
import { CollapsibleFeaturesList } from "./CollapsibleFeaturesList";
import { TRIAL_INCLUDED_FEATURES } from "./trialFeaturesData";

type TrialLearnMoreDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    handleSelectPlan: () => void;
    modalClassName?: string;
    className?: string;
    feature?: string;
    source: string;
};

export function TrialLearnMoreDialog({
    isOpen,
    onClose,
    handleSelectPlan,
    modalClassName,
    className,
    feature,
    source
}: TrialLearnMoreDialogProps) {
    useEffect(() => {
        if (isOpen) {
            window.eventTracker.event({
                type: "Trial Modal Opened",
                data: {
                    workspace: window.currentWorkspace,
                    feature: feature || null,
                    source: source
                }
            });
        }
    }, [isOpen, feature, source]);

    return (
        <ModalWithTitle
            modalClassName={modalClassName}
            className={className}
            isOpen={isOpen}
            onClose={onClose}
            title="Welcome to the Premium Trial!"
            headerClassName="pb-4"
            size="lg"
            showFooter={true}
            footerComponent={
                <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-700">
                        Interested in other features or higher limits?
                    </p>
                    <Button
                        type="upgrade"
                        size="medium"
                        onClick={() => {
                            window.eventTracker.event({
                                type: "Premium Trial ModalUpgrade Plan Button Clicked",
                                data: { workspace: window.currentWorkspace }
                            });
                            onClose();
                            handleSelectPlan();
                        }}
                    >
                        Upgrade Plan
                    </Button>
                </div>
            }
        >
            <PlanCard
                icon={getIconForWorkspacePlan("trial")}
                title="Premium Trial"
                description="Enjoy premium features, expanded limits, and priority support."
                customChip={<TrialExpirationChip />}
                whatsIncludedItems={[
                    {
                        icon: "far fa-lock",
                        text: (
                            <>
                                <span className="font-semibold">Private</span> data
                            </>
                        )
                    },
                    {
                        icon: "far fa-coins",
                        text: (
                            <>
                                <span className="font-semibold">
                                    {PLAN_UBP[Plan.UbpPremiumTrial].includedCredits}
                                </span>{" "}
                                credits
                            </>
                        )
                    },
                    { icon: "far fa-project-diagram", text: "Model Eval and Monitoring" },
                    { icon: "far fa-envelope", text: "Premium support" }
                ]}
            />

            <CollapsibleFeaturesList includedFeatures={TRIAL_INCLUDED_FEATURES} />
        </ModalWithTitle>
    );
}
